var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "md-column" } },
    [
      _c(
        "md-theme",
        { attrs: { "md-name": "blue" } },
        [
          _c(
            "md-dialog",
            {
              ref: "confirmLeave",
              attrs: { "md-click-outside-to-close": false }
            },
            [
              _c("md-dialog-title", [_vm._v("Please confirm")]),
              _c("md-dialog-content", [
                _c("p", [
                  _vm._v(
                    "You are just about to leave this page and your video will be"
                  ),
                  _c("strong", [_vm._v(" discarded.")])
                ])
              ]),
              _c(
                "md-dialog-actions",
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-primary",
                      nativeOn: {
                        click: function($event) {
                          return _vm.leaveThePage.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("Confirm")]
                  ),
                  _c(
                    "md-button",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.$refs.confirmLeave.close()
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("md-progress", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadingComponent,
            expression: "loadingComponent"
          }
        ],
        staticClass: "md-accent",
        attrs: { "md-indeterminate": "md-indeterminate" }
      }),
      _c(
        "md-theme",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loadingComponent,
              expression: "!loadingComponent"
            }
          ],
          attrs: { "md-name": "blue" }
        },
        [
          _c("breadcrumbs", {
            attrs: { id: "scrollToError", section: "Videos", nav: _vm.nav }
          }),
          _c(
            "md-layout",
            { staticClass: "form-wrapper", attrs: { "md-gutter": 16 } },
            [
              !_vm.editMode
                ? _c(
                    "md-layout",
                    { attrs: { "md-flex": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("video-uploader", {
                            attrs: {
                              "form-submitted": _vm.formSubmitted,
                              validations: _vm.$v
                            },
                            on: {
                              uploadSuccess: _vm.onUploadSuccess,
                              uploadFailed: _vm.onUploadFailure,
                              uploadCancel: _vm.onUploadCancel,
                              videoUploading: _vm.onVideoUploading,
                              videoName: _vm.onVideoName,
                              videoDuration: _vm.onVideoDuration
                            }
                          }),
                          _c("subtitle-uploader", {
                            attrs: { subtitlesProp: _vm.mediaItem.subtitles },
                            on: {
                              "subtitle-uploaded": _vm.onSubtitleUploaded,
                              "delete-subtitle": _vm.deleteSubtitle
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.editMode
                ? _c(
                    "md-layout",
                    { attrs: { "md-flex": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("media-item-preview", {
                            attrs: { "media-item": _vm.mediaItem },
                            on: { videoDuration: _vm.onVideoDuration }
                          }),
                          _c("subtitle-uploader", {
                            attrs: {
                              subtitlesProp: _vm.mediaItem.subtitles,
                              isEditMode: _vm.editMode
                            },
                            on: {
                              "subtitle-uploaded": _vm.onSubtitleUploaded,
                              "delete-subtitle": _vm.deleteSubtitle
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.editMode && _vm.mediaItem.poster && _vm.mediaItem.thumbnails
                ? _c(
                    "md-layout",
                    { attrs: { "md-flex": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("poster-selector", {
                            attrs: { "media-item": _vm.mediaItem },
                            on: {
                              update: _vm.updatePoster,
                              deleteCustom: _vm.deleteCustomThumbnail
                            }
                          }),
                          _c("md-layout", { attrs: { "md-flex": "100" } })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "md-layout",
                { attrs: { "md-flex": "100" } },
                [
                  _c(
                    "md-whiteframe",
                    {
                      staticClass: "form-wrapper-frame",
                      attrs: { "md-elevation": "3" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "md-headline" },
                        [
                          _vm._v("Images"),
                          _vm.noImagesLive
                            ? _c("p", { staticClass: "errorMessage" }, [
                                _vm._v(
                                  'If status is "live" the images are required'
                                )
                              ])
                            : _vm._e(),
                          _c("image-upload-croped", {
                            attrs: {
                              accountID: _vm.accountID,
                              "media-item": _vm.mediaItem,
                              "is-media-item": true
                            },
                            on: {
                              uploadSuccessPoster:
                                _vm.onUploadCustomImageSuccess,
                              uploadSuccessHero: _vm.onHeroImageUploadSuccess,
                              uploadSuccessPortrait: _vm.onUploadPortraitSuccess
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                [
                  _c(
                    "md-whiteframe",
                    {
                      staticClass: "form-wrapper-frame",
                      attrs: { "md-elevation": "3" }
                    },
                    [
                      _c("metadata-form", {
                        attrs: {
                          title: "Video",
                          entity: _vm.mediaItem,
                          "form-submitted": _vm.formSubmitted,
                          validations: _vm.$v.mediaItem
                        }
                      }),
                      _c("status-radio", {
                        on: {
                          input: function($event) {
                            return _vm.statusChanged($event)
                          }
                        },
                        model: {
                          value: _vm.mediaItem.status,
                          callback: function($$v) {
                            _vm.$set(_vm.mediaItem, "status", $$v)
                          },
                          expression: "mediaItem.status"
                        }
                      }),
                      _vm.mediaItem.status === "public" ||
                      _vm.mediaItem.publicationDate.date
                        ? _c(
                            "div",
                            { staticClass: "container-info" },
                            [
                              _c("md-icon", {
                                staticClass: "icon-info",
                                attrs: { "md-iconset": "fa fa-info" }
                              }),
                              _c("p", { staticClass: "check-properties" }, [
                                _vm._v(
                                  "Please, check video properties if you want this video in the Marketplace."
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                [
                  _c(
                    "md-whiteframe",
                    {
                      staticClass: "form-wrapper-frame",
                      attrs: { "md-elevation": "3" }
                    },
                    [
                      _c("content-targets-form", {
                        attrs: {
                          entity: _vm.mediaItem,
                          "form-submitted": _vm.formSubmitted,
                          validations: _vm.mediaItem
                        },
                        on: {
                          created: function($event) {
                            return _vm.showAlertToast($event, "success")
                          },
                          error: function($event) {
                            return _vm.showAlertToast($event, "error")
                          }
                        }
                      }),
                      _c("playlist-selector", {
                        attrs: {
                          multiple: true,
                          value: _vm.mediaItem.playlists
                        },
                        on: { input: _vm.selectedPlaylist }
                      }),
                      _c("rental-pricing-form", {
                        attrs: {
                          price: _vm.getPriceAmount(_vm.mediaItem.prices)
                        },
                        on: { "price-selected": _vm.handlePriceSelected }
                      }),
                      _c("date-input-time", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mediaItem.status === "draft",
                            expression: 'mediaItem.status === "draft"'
                          }
                        ],
                        attrs: {
                          publicationDate: _vm.mediaItem.publicationDate,
                          label: "Release Date",
                          formSubmitted: _vm.formSubmitted,
                          validation: _vm.$v.mediaItem.publicationDate,
                          status: _vm.mediaItem.status
                        },
                        on: { publicationDateEmit: _vm.publicationDateEmitter }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                [
                  _c(
                    "md-whiteframe",
                    {
                      staticClass: "form-wrapper-frame",
                      attrs: { "md-elevation": "3" }
                    },
                    [_c("language-form", { attrs: { entity: _vm.mediaItem } })],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                [
                  _c(
                    "md-whiteframe",
                    {
                      staticClass: "form-wrapper-frame",
                      attrs: { "md-elevation": "3" }
                    },
                    [
                      _c("properties-form", {
                        attrs: {
                          entity: _vm.mediaItem,
                          "form-submitted": _vm.formSubmitted,
                          validations: _vm.$v.mediaItem
                        },
                        on: {
                          created: function($event) {
                            return _vm.showAlertToast($event, "success")
                          },
                          error: function($event) {
                            return _vm.showAlertToast($event, "error")
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                [
                  _c(
                    "md-whiteframe",
                    {
                      staticClass: "form-wrapper-frame",
                      attrs: { "md-elevation": "3" }
                    },
                    [
                      _c("content-serie-form", {
                        attrs: {
                          entity: _vm.mediaItem,
                          "form-submitted": _vm.formSubmitted,
                          "episode-number-error": _vm.episodeNumberError,
                          "season-number-error": _vm.seasonNumberError
                        },
                        on: { isMiniSerie: _vm.isMiniSerieFunction }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                [
                  _c(
                    "md-whiteframe",
                    {
                      staticClass: "form-wrapper-frame",
                      attrs: { "md-elevation": "3" }
                    },
                    [
                      _c("credits-form", {
                        attrs: { entity: _vm.mediaItem, title: "Credits" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "100", "md-flex-small": "100" } },
                [
                  _c(
                    "md-whiteframe",
                    {
                      staticClass: "form-wrapper-frame",
                      attrs: { "md-elevation": "3" }
                    },
                    [
                      _c("div", { staticClass: "md-headline" }, [
                        _vm._v("Ad Breaks")
                      ]),
                      _vm.mediaItem.videoDuration === 0
                        ? _c("p", [
                            _vm._v(
                              "You must select a video to have the adbreaks options."
                            )
                          ])
                        : _c(
                            "div",
                            [
                              _vm.mediaItem.videoDuration < 420
                                ? _c("p", [
                                    _vm._v(
                                      "This video cannot have ad breaks because it is less than 7 minutes long. It will only have a pre-roll."
                                    )
                                  ])
                                : _c("media-item-roku-ad-breaks", {
                                    attrs: {
                                      mediaItem: _vm.mediaItem,
                                      "form-submitted": _vm.formSubmitted
                                    }
                                  })
                            ],
                            1
                          )
                    ]
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editMode,
                      expression: "!editMode"
                    }
                  ],
                  staticClass: "disclaimer-check",
                  attrs: {
                    "md-align": "center",
                    "md-flex": "50",
                    "md-flex-offset": "25"
                  }
                },
                [
                  _c("div", { staticClass: "md-caption" }, [
                    _vm._v(
                      "I own and/or have the right to distribute this content across domains, geographic regions, platforms, and windows of time specified in accordance with the associated licenses attached to this content or perpetually, and without restriction in the absence of attached licenses."
                    )
                  ]),
                  _c(
                    "md-checkbox",
                    {
                      staticClass: "md-primary md-body-2",
                      model: {
                        value: _vm.mediaItem.accountHasRights,
                        callback: function($$v) {
                          _vm.$set(_vm.mediaItem, "accountHasRights", $$v)
                        },
                        expression: "mediaItem.accountHasRights"
                      }
                    },
                    [_vm._v("I own or can distribute this content.")]
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-align": "center", "md-flex": "100" } },
                [
                  _c("stitch-loader", {
                    attrs: { loading: _vm.creatingOrUpdating, size: 40 }
                  }),
                  _c(
                    "md-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.creatingOrUpdating,
                          expression: "!creatingOrUpdating"
                        }
                      ],
                      staticClass: "md-raised md-primary",
                      attrs: {
                        id: "submit-btn",
                        disabled:
                          _vm.$v.$pending || !_vm.mediaItem.accountHasRights
                      },
                      on: { click: _vm.onFormSubmit }
                    },
                    [_vm._v(_vm._s(_vm.editMode ? "Update" : "Create"))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5d4baa2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5d4baa2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/mediaItem/MediaItemForm.vue
// module id = 969
// module chunks = 0